import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { TagMemberSize, TagMemberType } from '@design-system/components/molecules/tag-member/entities/tag-member.types';
import { TagMemberTypeDs, TagType, TagTypeLabel } from '@ux/components/member-rate-tag/entities/tag-type';

@Component({
  selector: 'app-member-rate-tag',
  templateUrl: './member-rate-tag.component.html',
  styleUrls: ['./member-rate-tag.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MemberRateTagComponent {

  @Input() tagType: TagType;
  @Input() extraClass: string;

  public readonly tagMemberSize = TagMemberSize.SM;

  constructor() { }

  get isValidTag(): boolean {
    return !!this.tagType && Object.values(TagType).includes(this.tagType);
  }

  get label(): string {
    return this.tagType ? TagTypeLabel[this.tagType] : '';
  }

  get tagMemberType(): TagMemberType {
    return TagMemberTypeDs?.[this.tagType] ?? null;
  }
}
